module.exports = __webpack_public_path__ + "static/img/user.6c1475b5.svg";